(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "cb31039ebc9ce22881ae8f1495031ed1cb6943f2"
};